// extracted by css-extract-rspack-plugin
export default {"returnsPolicy":"_2a7e8f3b","title":"_d8c98bc2","titleTop":"_fece31a9"};